<ng-template #content><ng-content></ng-content></ng-template>
@if (loading()) {
  <div class="overlay h-full">
    <p-progress-spinner  class="spinner w-12 h-12"></p-progress-spinner>
    <div class="content h-full">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </div>
}
@else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}
